import apiSkobo from "@/helpers/api/apiSkobo";

export const useConfidentialLoggingSetup = () => {
  const logActivity = async (
    appConfidentialId: string,
    system: string,
    objectId: string,
    driveId: string,
    itemId: string,
    action: string,
    metadata: Record<string, unknown>
  ) => {
    if (import.meta.env.VITE_APP_DO_LOG_ACTIVITY == "true") {
      try {
        apiSkobo.post(`/appconfidentialfolder/${appConfidentialId}/log`, {
          system,
          action,
          objectId,
          driveId,
          itemId,
          metadata
        });
        // eslint-disable-next-line no-empty
      } catch {}
    }
  };

  return { logActivity };
};
